<h2 mat-dialog-title>{{ isEdit ? 'Fahrzeug bearbeiten' : 'Fahrzeug anlegen' }}</h2>
<mat-dialog-content class="dialog-content">
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Kennzeichen</mat-label>
            <input matInput [formControl]="kennzeichenCtrl" placeholder="VEC-DR-23" />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Haupt-Suffix</mat-label>
            <input matInput [formControl]="suffixCtrl" placeholder="18" (blur)="onSuffixBlur()" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [formControl]="bezeichnungCtrl" />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Modell</mat-label>
            <input matInput [formControl]="modellCtrl" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Art</mat-label>
            <input matInput [formControl]="fahrzeugArtCtrl" placeholder="PKW" />
        </mat-form-field>
        <div class="flex ta-field">
            <kiene-autocomplete
                (elementSelected)="setTierarzt($event)"
                [apiUrl]="'tierarzt/'"
                [displayFields]="['titel', 'vorname', 'nachname']"
                [focus]="false"
                [kieneObject]="tierarzt"
                [placeholder]="'Tierarzt'"
                [required]="false"
            ></kiene-autocomplete>
        </div>
    </div>
    <div class="one-row">
        <mat-checkbox [formControl]="aktivCtrl">Aktiv</mat-checkbox>
    </div>
    <mat-form-field class="full">
        <mat-label>Kommentar</mat-label>
        <textarea matInput rows="2" [formControl]="kommentarCtrl"></textarea>
    </mat-form-field>

    <h3>Suffixe je Kostenart</h3>
    <p class="hint">
        Abweichende Suffixe (z.&nbsp;B. Zinsen 2120) hier setzen. Rechts: Konto im Kontenrahmen vorhanden?
    </p>
    <table class="ka-table">
        <thead>
            <tr>
                <th>Kostenart</th>
                <th>Suffix</th>
                <th>Konto</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let sach of sachkontoKeys">
                <td>{{ labelFor(sach) }}</td>
                <td>
                    <input
                        class="suf-input"
                        [(ngModel)]="suffixBySachkonto[sach]"
                        (blur)="onSuffixBlur()"
                        placeholder="z.B. 04"
                    />
                </td>
                <td class="status" [class.missing]="kontoStatus[sach]?.startsWith('fehlt')">
                    {{ kontoStatus[sach] || '–' }}
                </td>
                <td>
                    <button mat-icon-button type="button" (click)="removeKostenart(sach)" title="Entfernen">
                        <mat-icon>close</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="one-row add-row">
        <mat-form-field>
            <mat-label>Weitere Kostenart</mat-label>
            <input matInput [formControl]="extraSachkontoCtrl" placeholder="4830" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Suffix</mat-label>
            <input matInput [formControl]="extraSuffixCtrl" />
        </mat-form-field>
        <button mat-stroked-button type="button" (click)="addExtraKostenart()">Hinzufügen</button>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!isValid()" (click)="save()">
        Speichern
    </button>
</mat-dialog-actions>
